module.exports = __webpack_public_path__ + "img/AustraliaMap_SA.7fd14731.png";